module.exports = __webpack_public_path__ + "img/shop.449b5097.png";